import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import { PremiumPaidHistorySearchHandler } from './premium-paid-history-search.hander';

@Component({
  selector: 'sym-premium-paid-history-search',
  templateUrl: './premium-paid-history-search.component.html',
  styleUrls: ['./premium-paid-history-search.component.scss'],
})
export class PremiumPaidHistorySearchComponent extends PremiumPaidHistorySearchHandler implements OnInit {
  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
